import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

// Llamada a LaridaeRestServer
class CuadroDeMandoIngresoCompleto {
  getCuadroDeMandoIngresoCompleto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_cereal_total`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getTotalizadorCuadroDeMandoIngresoCompleto () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/cdmd_totalizador`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };

  getProductividadAltaComCuadroDeMandoIngresoCompleto () {
    const orden = '{"orden": ["usuario_alta_completa"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_productividad_altacom?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado.')
      return data
    })
  };
}

export default CuadroDeMandoIngresoCompleto
